import * as React from 'react';
import Box from '@mui/material/Box';
import CollumTransaction from './CollumTransaction';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';



export default function TabTransactions() {
    const { t } = useTranslation() as any
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', height: '48px', display: 'flex', alignItems: 'center', mx: 4 }}>
                <Typography variant="h6">
                    {t('34_00_transactions')}
                </Typography>
            </Box>
            <Box sx={{ p: 2 }}>
                <CollumTransaction />
            </Box>
        </Box>
    );
}